import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { closePopupAction } from "../../redux/actions/actions";
import "./GameInstructionsPopup.css";

const GameInstructionsPopup = () => {
  const dispatch = useDispatch();
  const openPopup = useSelector((state) => state.game.popup.open);

  const handleClosePopup = () => {
    dispatch(closePopupAction());
  };

  return (
    <div className={`popup ${openPopup ? "open" : ""}`} data-testid="popup">
      <div className="popup-content">
        <div className="popup-header">
          <h2 className="popup-title">GAME INSTRUCTIONS</h2>
        </div>
        <div className="popup-body">
          <div className="instruction-category">
            <h3 className="category-title">ACTIONS</h3>
            <ul style={{ textAlign: "left", listStyleType: "square"  }}>
              <li>Press 'Start Game' button to begin.</li>
              <li>Use arrow or "WASD" keys to move the ship.</li>
              <li>Press the spacebar to shoot.</li>
            </ul>
          </div>
          <div className="instruction-category">
            <h3 className="category-title">OBJECTIVES</h3>
            <ul style={{ textAlign: "left", listStyleType: "square" }}>
              <li>Avoid collisions with enemies.</li>
              <li>
                Score points by shooting enemy ships before they pass perimeter.
              </li>
              <li>Win by beating countdown and infiltrating enemy base</li>
            </ul>
          </div>
          <div className="instruction-category">
            <h3 className="category-title">DEFEAT</h3>
            <ul style={{ textAlign: "left", listStyleType: "square" }}>
              <li>Lose when enemy ship collides with your ship.</li>
              <li>Lose when number of lives is 0.</li>
              <li>Lose when enemy ship passes perimeter.</li>
            </ul>
          </div>
        </div>
        <div className="popup-footer">
          <button onClick={handleClosePopup} className="close-button">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameInstructionsPopup;
